class LocalizationOption extends window.BAO.CustomElement() {
	constructor() {
		super();
		this.selection = null;
		this.currentLocation = this.dataset.isoCode;
		this.availableOptions = [];
		this.position = -1;
	}

	connectedCallback() {
		super.connectedCallback();
	}

	setupListeners() {
		super.setupListeners();

		this.elements = {
			input: this.els.input.element,
			button: this.els.button.element,
			buttonLabel: this.els.buttonLabel.element,
			listItems: this.els.listItem.elements,
			search: this.els.search.element,
			panel: this.els.panel.element,
			submit: this.externalEls.submit.element,
			close: this.externalEls.close.element
		};

		this.querySelectorAll('a').forEach(item =>
			this.listeners.add(item, 'click', this.onItemClick.bind(this))
		);

		this.listeners.add(this.elements.button, 'click', this.openSelector.bind(this));
		this.listeners.add(this.elements.search, 'input', this.search.bind(this));
		this.listeners.add(this.elements.search, 'focus', this.search.bind(this));
		this.listeners.add(this.elements.button, 'focusout', this.closeSelector.bind(this));
		this.listeners.add(this.elements.submit, 'click', this.setLocation.bind(this));
		this.listeners.add(this.elements.close, 'click', this.hidePanel.bind(this));
		this.listeners.add(this, 'keyup', this.onContainerKeyUp.bind(this));
		this.listeners.add(this, 'keydown', this.handleKeyboardNav.bind(this));
	}

	handleKeyboardNav(e) {
		const last = this.availableOptions.length - 1;

		if (e.keyCode === 40) { // Down
			e.preventDefault();

			if (this.position === last) {
				return;
			}

			this.position += 1;
			if (this.availableOptions[this.position]) {
				this.availableOptions[this.position].focus();
			}
		}

		if (e.keyCode === 38) { // Up
			e.preventDefault();
			if (this.position < 1) {
				this.position = -1;
				this.elements.search.focus();
				return;
			}

			this.position -= 1;

			if (this.availableOptions[this.position]) {
				this.availableOptions[this.position].focus();
			}
		}

		if (e.keyCode === 13) { // Enter
			e.preventDefault();
			if (this.availableOptions[this.position]) {
				const link = this.availableOptions[this.position].querySelector('a');

				if (link) {
					link.click();
				}
			}
		}
	}

	search(e) {
		const { value } = e.target;
		this.position = -1;
		this.availableOptions = [];

		this.elements.listItems.forEach((listItem) => {
			const text = listItem.dataset.country;
			const regex = new RegExp(value, 'i');

			if (text.match(regex)) {
				listItem.setAttribute('aria-hidden', false);
				this.availableOptions.push(listItem);
			}
			else {
				listItem.setAttribute('aria-hidden', true);
			}
		});
	}

	clearSearch() {
		this.elements.search.value = '';
		this.position = -1;
		this.elements.listItems.forEach((listItem) => {
			listItem.setAttribute('aria-hidden', false);
		});
	}

	hidePanel() {
		this.clearSearch();
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		this.elements.input.value = event.currentTarget.dataset.value;
		this.elements.buttonLabel.innerText = event.currentTarget.innerText;
		this.selection = event.currentTarget.dataset.value;
		this.hidePanel();
	}

	setLocation() {
		window.localStorage.setItem(
			this.dataset.storageKey,
			this.selection || this.currentLocation,
		);
	}

	openSelector() {
		this.clearSearch();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute(
			'aria-expanded',
			(
				this.elements.button.getAttribute('aria-expanded') === 'false'
			).toString(),
		);
		this.elements.search.focus();
	}

	closeSelector(event) {
		const shouldClose =
			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-option', LocalizationOption);
